import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { shouldUseDsoStructure } from '~/growthbook';
import { useAppSelector } from '~/hooks/useAppSelector';
import { TNotAllowedReason } from './notAllowedReason';

interface IProps {
  children: ReactNode;
  customCondition?: boolean;
  /** Which popup the dashboard shows after a `customCondition` redirect (GOTU-8247). */
  notAllowedReason?: TNotAllowedReason;
}

export const NotAllowedGuard = ({
  children,
  customCondition,
  notAllowedReason = 'feature-unavailable',
}: IProps) => {
  const navigate = useNavigate();
  const selectedOfficeId = useAppSelector((state) => state.user.selectedOfficeId);

  const needsOfficeSelection = shouldUseDsoStructure() && !selectedOfficeId;

  useEffect(() => {
    // The DSO branch wins: no office is selected, so nothing else can be the
    // actionable reason.
    if (needsOfficeSelection) {
      navigate('/', { state: { showNotAllowedPopup: true, notAllowedReason: 'office-selection' } });
      return;
    }

    if (customCondition) {
      navigate('/', { state: { showNotAllowedPopup: true, notAllowedReason } });
    }
  }, [needsOfficeSelection, customCondition, notAllowedReason, navigate]);

  if (needsOfficeSelection) {
    return <></>;
  }

  return <>{children}</>;
};
